export default __webpack_public_path__ + "static/media/faq-header.1defbc17.jpg";